import React from "react";
import PropTypes from "prop-types";
import "../styles/principals-message.css";

/**
 * PrincipalsMessage
 *
 * Figma-aligned section:
 * - Background: #C8D9C8
 * - Paddings: L/R 150, T/B 105
 * - Two columns: left copy + principal name/role, right portrait image
 *
 * A11y:
 * - <h2> section heading (assumes <h1> is in the hero)
 * - Body supports <br/> via dangerouslySetInnerHTML (controlled content)
 */
const PrincipalsMessage = ({
  title = "Message from the Principal",
  body = `Welcome to The Avenue School. We’re a small, purpose-built school designed for students who’ve found mainstream education overwhelming or unworkable. From the beginning, we’ve been intentional about staying small—capping enrolments to ensure a calm, safe space for students who experience high anxiety or school refusal. We know that for many young people, large schools can be a barrier. Here, we remove that barrier.<br/><br/>Our approach is bespoke. We focus on what each student is interested in—whether it’s trades, nursing, or something else entirely—and use that to build confidence, engagement, and real-world skills. We’re not here to tick boxes. We’re here to connect, to support, and to help every student find a rewarding path forward.`,
  principalName = "Jarrid Bartle",
  principalRole = "Principal",
  imageSrc = "/media/jarrid.jpg",
  imageAlt = "Principal portrait",
}) => {
  return (
    <section className="pm-section">
      <div className="pm-wrap">
        {/* Left column: texts */}
        <div className="pm-left">
          <h2 className="pm-title">{title}</h2>
          <p
            className="pm-body"
            dangerouslySetInnerHTML={{ __html: body }}
          />
          <div className="pm-sig">
            <p className="pm-name">{principalName}</p>
            <p className="pm-role">{principalRole}</p>
          </div>
        </div>

        {/* Right column: image */}
        <div className="pm-right">
          <img
            className="pm-image"
            src={imageSrc}
            alt={imageAlt || ""}
          />
        </div>
      </div>
    </section>
  );
};

PrincipalsMessage.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string, // may include <br/>
  principalName: PropTypes.string,
  principalRole: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
};

export default PrincipalsMessage;
